const initialState = {
    licenceCredits: 0,
    greyFleetCredits: 0,
    locations: []
};

const LicenceCheckingReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_LICENCE_CREDITS":
            return {
                ...state,
                licenceCredits: action.payload
            };
        case "SET_GREY_FLEET_CREDITS":
            return {
                ...state,
                greyFleetCredits: action.payload
            };
        case "SET_LICENCE_CHECKING_LOCATIONS":
            return {
                ...state,
                locations: action.payload
            };
        case "RESET_STORE":
            state = initialState
            return state;
    }

    return state;
}

export default LicenceCheckingReducer;